import { render, staticRenderFns } from "./TifTurnoAutorizaciones.vue?vue&type=template&id=f497eea4"
import script from "./TifTurnoAutorizaciones.vue?vue&type=script&lang=js"
export * from "./TifTurnoAutorizaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports